<template>
  <div class="onTheGoList-container flex-column justify-content-start">
    <top-bar :title="'随手拍历史发布'"></top-bar>
    <div class="onTheGoList-content">
      <waterfall></waterfall>
    </div>
<!--    <div class="suspension" @click="showSend = true"></div>-->
  </div>
</template>
<script>
import top2 from "@/assets/home_new/onTheGo/top2.png";

import topBar from "../top-bar/index";
import waterfall from "./waterfall3";
import { VUE_APP_API_URL } from "@utils";
import back_01 from "../../assets/home_new/top1.png";
import back_02 from "../../assets/home_new/top2.png";
import back_03 from "../../assets/home_new/top3.png";
import back_04 from "../../assets/home_new/top4.png";
import back_05 from "../../assets/home_new/top5.png";
import back_06 from "../../assets/home_new/top6.png";
import back_07 from "../../assets/home_new/top7.png";
import * as imageConversion from "image-conversion";
import { uploadLesson} from "@/api/home";

export default {
  name: "onTheGoList",
  components: {
    topBar,
    waterfall
  },
  data() {
    return {
      route: {},
      top2: top2,
      showSend: false,
      imageUrl: undefined,
      textarea: "",
      file: undefined,
      dataInfo: {},
      dataList: [
        {
          title: "中国北方重要生态安全屏障", //国家重要能源和战略资源基地
          comments_count: 0,
          content: "",
          src: back_01,
          id: "A",
          post_id: "5310906",
          time: "2020-04-11 16:59:15",
          desc: "asdf"
        },
        {
          title: "祖国北疆安全稳定屏障", //国家重要农畜产品生产基地
          comments_count: 0,
          content: "",
          src: back_02,
          id: "B",
          post_id: "5310903",
          time: "2020-04-11 16:09:09",
          desc: "asdf"
        },
        {
          title: "国家重要能源和战略资源基地", //国门
          comments_count: 0,
          content: "",
          src: back_03,
          id: "C",
          post_id: "5310813",
          time: "2020-04-11 15:40:02",
          desc: "asdf"
        },
        {
          title: "国家重要农畜产品生产基地", //民族团结
          comments_count: 0,
          content: "",
          src: back_04,
          id: "D",
          post_id: "5310813",
          time: "2020-04-11 15:40:02",
          desc: "asdf"
        },
        {
          title: "国际向北开放重要桥头堡", //青春正能量
          comments_count: 0,
          content: "",
          src: back_05,
          id: "E",
          post_id: "5310813",
          time: "2020-04-11 15:40:02",
          desc: "asdf"
        },
        {
          title: "民族团结", //中国北方重要生态安全屏障
          comments_count: 0,
          content: "",
          src: back_06,
          id: "F",
          post_id: "5310813",
          time: "2020-04-11 15:40:02",
          desc: "asdf"
        },
        {
          title: "青春正能量", //祖国北疆安全稳定屏障
          comments_count: 0,
          content: "",
          src: back_07,
          id: "G",
          post_id: "5310813",
          time: "2020-04-11 15:40:02",
          desc: "asdf"
        }
      ]
    };
  },
  created() {
    this.route = this.$route.query;
    for (const argument of this.dataList) {
      var s = argument.id + "";
      if (s === this.route.id) {
        this.dataInfo = argument;
      }
    }
    // getImageList().then(res => {
    //
    // });
  },
  mounted() {},
  destroyed() {},
  methods: {
    onProgress() {},
    onChange(file, fileList) {
      // this.file = file;
      var _this = this;
      imageConversion
        .compressAccurately(file.raw, 1024 * 8)//单位 kb
        .then(res => {
          console.log(res);
          _this.file = res;
          this.imageUrl = URL.createObjectURL(res);
        });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$tip({
          show: true,
          message: "上传头像图片只能是 JPG|png 格式!"
        });
        return;
      }
      if (!isLt2M) {
        this.$tip({
          show: true,
          message: "上传头像图片大小不能超过 2MB!"
        });
        return;
      }
      return isJPG && isLt2M;
    },
    upload() {
      var _this = this;
      var type = "";
      for (const dataListElement of this.dataList) {
        if (dataListElement.id === this.route.id) {
          type = dataListElement.id;
        }
      }
      let imgfile = new FormData();
      imgfile.append("files", this.file);
      imgfile.append("text", this.textarea);
      imgfile.append("type", type);
      this.$dialog.loading.open();
      uploadLesson(imgfile)
          .then(res => {
            _this.$dialog.loading.close();
            console.info(res);
            _this.$dialog.loading.close();
            _this.$tip({
              show: true,
              message: "上传成功"
            });
            _this.clear();
          })
          .catch(e => {
            _this.$dialog.loading.close();
            _this.$tip({
              show: true,
              message: e.message
            });
          });
      // this.$axios({
      //   url: `${VUE_APP_API_URL}/home/uploadLesson`,
      //   method: "post",
      //   data: imgfile,
      //   headers: {
      //     "Content-Type": "multipart/form-data"
      //   }
      // })
      //   .then(function(res) {
      //     _this.$dialog.loading.close();
      //     _this.showSend = false;
      //     _this.$tip({
      //       show: true,
      //       message: "上传成功"
      //     });
      //   })
      //   .catch(function(err) {
      //     _this.$dialog.loading.close();
      //     _this.$tip({
      //       show: true,
      //       message: err.message
      //     });
      //   });
    }
  }
};
</script>

<style scoped>
@import "../../assets/css/flex.css";
@import "../../assets/css/font-title.css";

.dialog {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  background-color: rgba(169, 169, 169, 0.31);
}

.dialog-group {
  background-color: #ffffff;
  border-radius: 15px;
  width: 80%;
  max-height: 80%;
  height: auto;
}

.dialog-content {
  width: 100%;
  padding: 10px 20px 0 20px;
}

.dialog-head {
  width: 100%;
}

.dialog-head-title {
  width: calc(100% - 0.4rem);
  font-size: 0.35rem;
  font-weight: bold;
  font-family: JDZY;
}

.dialog-head-closed {
  width: 0.4rem;
  font-size: 0.4rem;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.onTheGoList-container {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background-color: #f1f1f1;
  margin-bottom: 20px;
}

.suspension {
  position: fixed;
  width: 1.2rem;
  height: 1.2rem;
  bottom: 1.4rem;
  right: 1rem;
  background: url(../../assets/home_new/onTheGo/suspension.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
}

.onTheGoList-content {
  height: 100%;
  padding: 0 20px 0 20px;
}
</style>
